import { request } from "../helper/axios_helper";

export const addVariables = (data) => {
  return request("POST", "/api/auth/admin/add", data);
};

// Upsert a settings group (rows all share dataType/dataSubType).
export const saveSettings = (rows) => {
  return request("POST", "/api/auth/admin/settings/save", rows);
};

export const getAllEnvironment = () => {
  return request("GET", "/api/auth/admin/get/environments");
};

export const deleteEnvironmentByName = (displayName) => {
  return request(
    "DELETE",
    `/api/auth/admin/delete/environments/${displayName}`
  );
};

export const getDataSubTypeByType = (dataType, dataSubType) => {
  const url = `/api/auth/admin/get/${dataType}${
    dataSubType ? `/${dataSubType}` : ""
  }`;
  return request("GET", url);
};
